






















































import Vue from 'vue';
import Component from 'vue-class-component';
import {Model, Prop, Watch} from 'vue-property-decorator';
import Grid from '../../ae-grid';
import Icon from '../../ae-icon';
import DSelect from '../../d-select';

Vue.use(Icon);
Vue.use(Grid);
@Component({
  name: 'DYearPicker',
  components: {
    DSelect
  }
})
export default class DYearPicker extends Vue {
  @Model('change')
  private value!: any;
  @Prop({type: Boolean, default: false})
  private clearable!: boolean;
  @Prop({
    type: Function,
    default: () => false
  })
  private disabledDate!: (year: string) => boolean;
  @Prop(Number)
  public max: number;
  @Prop(Number)
  public min: number;
  @Prop({type: Boolean, default: false})
  private multiple!: boolean;
  private currentValue: number[] | number = this.multiple ? [] : null;
  @Prop({default: '请选择年份', type: String})
  private placeholder!: string;
  private year: number = new Date().getFullYear();

  get startYear(): number {
    return Math.floor(this.year / 10) * 10;
  }

  @Watch('min', {immediate: true})
  public minChanged(min: number) {
    if (min) {
      this.year = this.min;
    }
  }

  @Watch('currentValue', {immediate: true})
  public onSelectedChange(currentValue: string[] | string) {
    this.$emit('change', currentValue);
  }

  @Watch('value', {immediate: true})
  public valueChanged(value: number | number[]) {
    if (this.currentValue !== value) {
      this.currentValue = value;
      if (this.multiple) {
        if ((value as number[]).length) {
          this.year = (value as number[])[0];
        }
      } else {
        this.year = value as number;
      }
    }
  }

  public endYear() {
    return this.startYear + 10;
  }

  public getItemClass(index: number) {
    const {multiple, currentValue, startYear} = this;
    const year = startYear + index - 1;
    return {
      selected: multiple ? (currentValue as number[]).includes(year) : currentValue === year,
      disabled: (this.min && year < this.min) || (this.max && year > this.max)
    };
  }

  private shouldDisabled(year: string) {
    return this.disabledDate(year);
  }

  private switchYearToLeft() {
    this.year -= 10;
  }

  private switchYearToRight() {
    this.year += 10;
  }

  public toggleValue(value: number, event: MouseEvent) {
    const select = this.$refs.select as any;
    if (this.multiple) {
      const val = this.currentValue as number[];
      if (val.includes(value)) {
        val.splice(val.indexOf(value), 1);
      } else {
        val.push(value);
      }
    } else {
      if (value !== this.currentValue) {
        this.currentValue = value;
      }
      select.close();
    }
  }

}
